exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ba-alert-navigator-buttons{min-width:80px}.ba-alert-navigator-buttons .ba-common-button.is-variant_solid{min-width:40px;width:40px;padding:0;background-color:#343334}.ba-alert-navigator-buttons .ba-common-button.is-variant_solid:hover:not(.is-disabled):not(.is-tap){background-color:#595859}.ba-alert-navigator-buttons .ba-common-button.is-disabled{opacity:1;background-color:#595859}.ba-alert-navigator-buttons .ba-common-button.is-disabled svg{opacity:.5}", ""]);

// exports
exports.locals = {
	"alertNavigatorButtonsClassName": "\"ba-alert-navigator-buttons\""
};